import React from 'react';

import { Table, Button, Icon, Rating, Label, Popup } from 'semantic-ui-react';

import clsx from 'clsx';
import { useSelector } from 'react-redux';

import {
  getActionLabelForReview,
  getPublishAt,
  getStatusLabelProps,
  getLocationName,
} from './ReviewsTableRow.utils';
import {
  formatLocaleDate,
  formatLocaleDatetime,
} from '../../../../../libs/date-utils/date-formatting';
import { selectBusinessLocations } from '../../../../../selectors';
import {
  getReviewResponse,
  getSourceIconName,
  isCustomReview,
  isReviewFlagged,
  getReviewFlaggedReason,
} from '../ReviewsTable/ReviewsTable.utils';
import { isReviewResponseSubmitted } from '../ReviewsTableModal/ReviewsTableModal.utils';

import './ReviewsTableRow.scss';

export default function ReviewsTableRow({ className, onReplyClick, review }) {
  const locations = useSelector(selectBusinessLocations);

  const { author, text, source, rating, reviewDate, status, location } = review;
  const reviewResponse = getReviewResponse(review);
  const isSubmitted = isReviewResponseSubmitted(reviewResponse);
  const isFlagged = isReviewFlagged(review);
  const flaggedReason = getReviewFlaggedReason(review);

  const { icon: statusIcon, color: statusColor, label: statusLabel } = getStatusLabelProps(status);
  const { icon: actionIcon, label: actionLabel } = getActionLabelForReview(review);
  const publishAt = getPublishAt(review);
  const locationName = getLocationName(location, locations);

  return (
    <Table.Row className={clsx('reviews-table-row', className)}>
      <Table.Cell>
        <div className="author">{author}</div>
        <div className="date">{formatLocaleDate(reviewDate)}</div>
      </Table.Cell>
      <Table.Cell textAlign="center">
        {!isCustomReview(source) && <Icon name={getSourceIconName(source)} />}
      </Table.Cell>
      <Table.Cell>
        <Rating maxRating={5} rating={rating} disabled />
      </Table.Cell>
      <Table.Cell>
        <div className="text">{text}</div>
      </Table.Cell>
      <Table.Cell>
        <div className="location">{locationName}</div>
      </Table.Cell>
      <Table.Cell textAlign="center" className="status">
        {isFlagged && (
          <Popup
            content={flaggedReason}
            trigger={
              <Label basic circular>
                <Icon name="flag" color="red" />
                Flagged
              </Label>
            }
          />
        )}

        {publishAt && !isSubmitted ? (
          <Label basic>
            <Icon name="clock" color={statusColor} />
            Scheduled for {formatLocaleDatetime(publishAt)}
          </Label>
        ) : (
          <Label basic circular>
            <Icon name={statusIcon} color={statusColor} />
            {statusLabel}
          </Label>
        )}
      </Table.Cell>
      <Table.Cell>
        {isSubmitted ? (
          <Button basic onClick={() => onReplyClick(review)}>
            View
          </Button>
        ) : (
          <Button primary onClick={() => onReplyClick(review)}>
            {actionIcon && <Icon name={actionIcon} />}
            {actionLabel}
          </Button>
        )}
      </Table.Cell>
    </Table.Row>
  );
}
